export default function PageTitle({
  title,
  total = 0,
  search = '',
  description = '',
}) {
  return (
    <>
      {title} {total > 0 && <><small>({total})</small></>}
      {search !== '' && <small style={{textTransform: 'lowercase'}}>&nbsp;{`Searched by: ${search}`}</small>}
      {description && <><br /><small style={{
        fontSize: '16px',
        lineHeight: '24px',
        color: 'var(--neutral80-color)',
      }}>{description}</small></>}
    </>
  );
}
